<template>
  <div class="search-container">
    <el-form ref="form" inline>
      <el-form-item label="地址" label-width="80px">
        <el-input v-model="address" clearable></el-input>
      </el-form-item>
      <el-form-item label-width="0">
        <el-button type="primary" @click="getLbs()">
          <el-icon><search /></el-icon>查询
        </el-button>
      </el-form-item>
    </el-form>
  </div>
  <div id="map_container" style="height: 78vh;"></div>
</template>

<script>
let tencentMap, myMarkerStyle, markerLayer, markerCluster, infoWindow

export default {
  name: "门店地图",
  props: {
    currentUser: Object
  },
  data() {
    return {
      myPositionIcon: require('@/assets/my-position.png'),
      address: '',
      position: {
        lat: 39.908552,
        lng: 116.397481
      },
      shops: []
    }
  },
  methods: {
    getLbs() {
      this.$apis.common.getLbs(this.address).then(response => {
        this.position.lat = response.data[1]
        this.position.lng = response.data[0]
        this.getShops()
      })
    },
    getShops() {
      this.$apis.shopMap.getShops(0, 50, this.position.lat, this.position.lng).then(response => {
        console.log(response)
        this.shops = response.data
        this.initMap()
      })
    },
    initMap() {
      console.log('初始化腾讯地图', tencentMap)
      let center = new TMap.LatLng(this.position.lat, this.position.lng)
      if (!tencentMap) {
        tencentMap = new TMap.Map('map_container', {
          zoom: 14, //设置地图缩放级别
          center: center //设置地图中心点坐标
        })
        myMarkerStyle = new TMap.MarkerStyle({
          width: 48,
          height: 48,
          src: this.myPositionIcon
        })
      } else {
        tencentMap.setCenter(center)
      }

      let markerGeo = {
        id: 'center',
        styleId: 'marker',
        position: tencentMap.getCenter()
      }
      if (!markerLayer) {
        // 创建一个位于地图中心点的marker
        markerLayer = new TMap.MultiMarker({
          map: tencentMap,
          styles: {
            marker: myMarkerStyle
          },
          geometries: [
            markerGeo
          ]
        })
      } else {
        markerLayer.updateGeometries([markerGeo])
      }
      let geometries = []
      if (this.shops) {
        for (let i = 0; i < this.shops.length; i++) {
          let shop = this.shops[i]
          geometries.push({
            id: 'p-' + i,
            position: new TMap.LatLng(shop.lat, shop.lng)
          })
        }
      }
      if (!markerCluster) {
        markerCluster = new TMap.MarkerCluster({
          id: 'cluster',
          map: tencentMap,
          enableDefaultStyle: true,
          minimumClusterSize: 2,
          zoomOnClick: true,
          gridSize: 60,
          averageCenter: false,
          maxZoom: 16,
          geometries: geometries
        })
      } else {
        markerCluster.updateGeometries(geometries)
      }
      if (!infoWindow) {
        infoWindow = new TMap.InfoWindow({
          map: tencentMap,
          position: new TMap.LatLng(this.position.lat, this.position.lng),
          offset: { x: 7, y: -38 }
        })
        infoWindow.close()
      }
      let _that = this
      markerCluster.on('click', function (evt) {
        if (evt.cluster.geometries.length === 1) {
          const temp = evt.cluster.geometries[0]
          const index = Number(temp.id.split('-')[1])
          const shop = _that.shops[index]
          infoWindow.open(); //打开信息窗
          infoWindow.setPosition(temp.position);//设置信息窗位置
          infoWindow.setContent('<div class="shop_info">' +
              '<div class="name">' + shop.companyName + '<span class="distance color_normal">' + shop.distance.toFixed(2) + 'km</span></div>' +
              '<div class="address color_info">' + shop.provinceName + (shop.cityName !== shop.provinceName ? shop.cityName : '') + shop.countyName + shop.address + '</div>' +
              '</div>');//设置信息窗内容
        }
      })
    }
  },
  created() {
    if (tencentMap) {
      tencentMap.destroy()
      tencentMap = null
      myMarkerStyle = null
      markerLayer = null
      markerCluster = null
      infoWindow = null
    }
    setTimeout(() => {
      this.initMap()
    }, 100)
  }
}
</script>

<style>
.shop_info {
  text-align: left;
}
.shop_info .name {
  font-weight: bold;
  font-size: 16px;
}
.shop_info .distance {
  margin-left: 6px;
  font-size: 14px;
  font-weight: normal;
}
.shop_info .address {
  font-size: 14px;
}
</style>